<h1 mat-dialog-title>
    {{success ? 'ΕΠΙΤΥΧΙΑ' : 'ΣΦΑΛΜΑ'}}
</h1>
<div mat-dialog-content>
    <p>{{success ? 'Η εγγραφή ολοκληρώθηκε' : 'Προέκυψε σφάλμα κατά την αποθήκευση των στοιχείων'}}</p>
</div>